import React, { useContext } from 'react';
import Context from '../../../../utils/context';
import styles from './index.module.css';

export default function AvatarWActive({ profile, showInfo = false }) {
  if (!profile) {
    return <></>;
  }

  const imageUrl = profile.photo || '';

  const context = useContext(Context);
  const profileStatus = context.profileStatus;
  profileStatus.addProfile(profile);

  var active = profile.active;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }} data-active-id={profile.id}>
      <div className={styles.avatarHolder}>
        <div
          className={styles.avatar}
          style={{
            backgroundImage: `url("${imageUrl}")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />
        <div
          data-avatar-profile-id={profile.id}
          data-avatar-profile-type={profile.type}
          className={`${styles.activeStatusLight} ${active ? styles.active : ''}`}
        ></div>
      </div>
      {showInfo && (
        <div style={{ flexDirection: 'column' }}>
          <p className={`bold ${styles.infoName}`}>{profile.display_name}</p>
          {profile.last_active && (
            <p
              data-last-active-profile-id={profile.id}
              data-last-active-profile-type={profile.type}
              className={styles.infoLastActive}
            >
              Active {profile.last_active_display}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
